var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "appContainer", staticClass: "app-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { offset: 8, span: 8 } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    "label-width": "80px",
                    model: _vm.user,
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [_c("userAvatar", { attrs: { user: _vm.user } })],
                    1
                  ),
                  _c("ul", { staticClass: "list-group list-group-striped" }, [
                    _c("li", { staticClass: "list-group-item" }, [
                      _c("span", [_vm._v("员工姓名：")]),
                      _c("span", { staticClass: "item-content" }, [
                        _vm._v(_vm._s(_vm.user.userName)),
                      ]),
                    ]),
                    _vm.showMobile
                      ? _c(
                          "li",
                          { staticClass: "list-group-item" },
                          [
                            _c("span", { staticClass: "before-item" }, [
                              _vm._v("手机号码："),
                            ]),
                            _c("span", { staticClass: "item-content" }, [
                              _vm._v(_vm._s(_vm.user.userPhone)),
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "ml10",
                                attrs: { type: "text" },
                                on: { click: _vm.editmobile },
                              },
                              [_vm._v(" 修改 ")]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "li",
                          { staticClass: "list-group-item" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "手机号码:",
                                  "label-width": "90px",
                                  prop: "userPhone",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "160px" },
                                  attrs: { maxlength: "11" },
                                  model: {
                                    value: _vm.user.userPhone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user, "userPhone", $$v)
                                    },
                                    expression: "user.userPhone",
                                  },
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml10",
                                    attrs: { type: "text" },
                                    on: { click: _vm.close },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: { click: _vm.Submit },
                                  },
                                  [_vm._v("保存")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c("span", [_vm._v("所属部门：")]),
                      _vm.user.deptFullName
                        ? _c("span", { staticClass: "item-content" }, [
                            _vm._v(" " + _vm._s(_vm.user.deptFullName) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c("span", [_vm._v("所属角色：")]),
                      _vm.user.roleName
                        ? _c("span", { staticClass: "item-content" }, [
                            _vm._v(" " + _vm._s(_vm.user.roleName) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c("span", [_vm._v("创建日期：")]),
                      _c("span", { staticClass: "item-content" }, [
                        _vm._v(_vm._s(_vm.user.createTime)),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }